import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

/**
 * Wrapper around React-Quill with a custom toolbar suitable for legal pages.
 * Stores HTML content. Caller is responsible for sanitizing on render.
 */
const TOOLBAR = [
  [{ header: [1, 2, 3, false] }],
  ["bold", "italic", "underline", "strike"],
  [{ list: "ordered" }, { list: "bullet" }],
  ["link", "blockquote"],
  [{ align: [] }],
  ["clean"],
];

export default function RichTextEditor({ value, onChange, placeholder, testid }) {
  const [internal, setInternal] = useState(value || "");
  const lastEmittedRef = useRef(value || "");

  // Sync external value -> internal only when it really changed
  useEffect(() => {
    if ((value || "") !== lastEmittedRef.current) {
      setInternal(value || "");
      lastEmittedRef.current = value || "";
    }
  }, [value]);

  const handle = (html) => {
    setInternal(html);
    lastEmittedRef.current = html;
    onChange && onChange(html);
  };

  return (
    <div data-testid={testid} className="rte-wrapper">
      <ReactQuill
        theme="snow"
        value={internal}
        onChange={handle}
        modules={{ toolbar: TOOLBAR }}
        placeholder={placeholder || ""}
      />
      <style>{`
        .rte-wrapper .ql-toolbar { background: var(--brand-surface-elevated); border-color: var(--brand-border) !important; }
        .rte-wrapper .ql-container { background: var(--brand-surface); border-color: var(--brand-border) !important; color: var(--brand-text-primary); min-height: 240px; font-size: 14px; }
        .rte-wrapper .ql-editor { min-height: 240px; }
        .rte-wrapper .ql-editor.ql-blank::before { color: rgba(255,255,255,0.35); font-style: italic; }
        .rte-wrapper .ql-snow .ql-stroke { stroke: var(--brand-text-secondary); }
        .rte-wrapper .ql-snow .ql-fill { fill: var(--brand-text-secondary); }
        .rte-wrapper .ql-snow .ql-picker-label { color: var(--brand-text-secondary); }
        .rte-wrapper .ql-snow .ql-picker-options { background: var(--brand-surface-elevated); color: var(--brand-text-primary); border-color: var(--brand-border); }
        .rte-wrapper .ql-snow.ql-toolbar button:hover .ql-stroke, .rte-wrapper .ql-snow.ql-toolbar button.ql-active .ql-stroke { stroke: var(--brand-primary); }
        .rte-wrapper .ql-snow.ql-toolbar button:hover .ql-fill, .rte-wrapper .ql-snow.ql-toolbar button.ql-active .ql-fill { fill: var(--brand-primary); }
      `}</style>
    </div>
  );
}
